<template lang='pug'>
  div(v-resize='onResize' :id='editorId')
</template>

<script>
import _ from 'lodash';
import * as monaco from 'monaco-editor';
import Monaco from '../services/monaco.service';
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsMonacoEditor',
  props: {
    mode: {
      type: String,
      default: 'javascript'
    },
    type: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'vs-dark'
    },
    guid: {
      type: String
    },
    gitName: {
      type: String
    },
    line: {
      type: Number
    },
    value: {
      default() {
        return '';
      }
    }
  },
  async mounted() {
    this.editorId = `editor-${this.randomNumber(5)}`;
    this.uri = Monaco.getUri({dir: this.type, guid: this.guid, gitName: this.gitName});
    console.log(`URI: ${this.uri}`);
    this.$nextTick(() => {
      this.setupEditor();
    });
  },
  beforeDestroy() {
    console.log('Disposing of editor');
    this.editor.dispose();
  },
  methods: {
    setupModel() {
      this.monacoModel = monaco.editor.getModel(this.uri);
      if (this.monacoModel) {
        console.log('Model already exists. Using existing one to keep undo history and such. Updating to latest code');
        if (this.value !== this.monacoModel.getValue()) {
          console.log('Models did not match - file changed by someone else, reloading');
          this.monacoModel.setValue(this.value);
          Notifications.toast('File edited since last load. Refreshed File.');
        }
      } else {
        console.log(`Model does not exist yet. Creating new one with URI: ${this.uri}`);
        this.monacoModel = monaco.editor.createModel(this.value, this.mode, this.uri);
      }
    },
    setupEditor() {
      this.setupModel();
      this.editor = monaco.editor.create(document.getElementById(this.editorId), {
        model: this.monacoModel,
        language: this.mode,
        theme: this.theme
      });
      this.monacoModel.onDidChangeContent(_.debounce(this.valueChanged, 300, {leading: true}));
      if (this.line) {
        const lineNumber = this.line;
        this.editor.revealLineInCenter(lineNumber);
        this.editor.setPosition({column: 1, lineNumber});
      }
    },
    // eslint-disable-next-line
    onResize: _.debounce(function () {
      this.editor.layout();
    }, 250),
    set(value) {
      this.monacoModel.setValue(value);
    },
    valueChanged() {
      this.$emit('input', this.monacoModel.getValue());
    },
    randomNumber(digits) {
      // eslint-disable-next-line
      return Math.floor(Math.pow(10, digits - 1) + Math.random() * (Math.pow(10, digits) - Math.pow(10, digits - 1) - 1));
    }
  },
  mixins: [],
  data() {
    return {
      uri: null,
      initialSet: true,
      editorId: 'editor',
      editor: null,
      monacoModel: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
